import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Necesito creer en espiritualidad para que funcione?',
    a: 'No. El MegaPack combina herramientas de psicología, neurociencia y finanzas personales con un marco espiritual. Si las herramientas prácticas resuenan con vos, los resultados llegan independientemente de tus creencias previas.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Apenas confirmado tu pago, recibís un mail en menos de 5 minutos con el link de descarga de todos los PDFs. Podés leerlos en el celular, tablet o computadora. También podés imprimirlos.'
  }, {
    q: '¿Funciona para la situación económica de Argentina?',
    a: 'Fue diseñado específicamente para Argentina. Cada herramienta, cada decreto y cada planilla financiera fue creada considerando la inflación, el peso, la tarjeta de crédito y los desafíos específicos del mercado argentino.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'Los resultados dependen de la consistencia de aplicación. El sistema fue diseñado para funcionar con solo 5 a 10 minutos de práctica diaria. Días 1 a 7: Identificación de contratos de pobreza y fugas energéticas. Días 8 a 14: Cambio en el lenguaje financiero y baja del estrés. Días 15 a 21: Primer presupuesto consciente y Deuda #1 en la mira. Días 22 a 30: Primera victoria financiera concreta y primera sincronía documentada. Días 31 a 90: Resultados financieros crecientes y canales de ingreso activados. Días 91 a 180: Transformación completa y sistema de blindaje activo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si abrís los tomos y en 7 días sentís que no es lo que esperabas, escribís a soportelumenakasha@gmail.com y te devolvemos el 100% sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-72">
      <div className="text-center mb-12" data-id="element-73">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[24px]" data-id="element-74">
          <span className="mr-3" data-id="element-75">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-76">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-pink/30 bg-white/60" data-id="element-77">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/30 transition-colors" data-id="element-78">
              <span className="font-medium pr-8 text-[16px] text-brand-text" data-id="element-79">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-80" />
            </button>
            <AnimatePresence data-id="element-81">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-82">
                  <div className="px-6 pb-5 text-brand-text/70 border-t border-brand-pink/20 pt-4 text-[14px] bg-white/40" data-id="element-83">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};